import { useState } from 'react';
import { ChevronDownIcon } from "@heroicons/react/outline";

const Accordion = ({ items, width }) => {
  return (
    <div className={`flex flex-col justify-start ${width || "w-full lg:w-1/2"}`}>
      {items.map(({ title, content }, index) => (
        <AccordionItem
          key={index}
          title={title}
          content={content}
          roundedClass={
            index === 0
              ? "rounded-t-lg"
              : index === items.length - 1
              ? "rounded-b-lg"
              : ""
          }
        />
      ))}
    </div>
  );
};

const AccordionItem = ({ title, content, roundedClass }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`bg-white border border-gray-200 ${roundedClass}`}>
      <div
        onClick={() => setOpen(!open)}
        className="flex justify-between items-center p-4 cursor-pointer font-medium"
      >
        <h6 className="max-w-[80%] text-gray-500 text-left">{title}</h6>
        <ChevronDownIcon
          className={` size-6 transition-transform duration-300 ${
            open ? "rotate-180" : "rotate-0"
          }`}
        />
      </div>

      <div
        className={`grid transition-all duration-300 ease-in-out overflow-hidden ${
          open
            ? "max-h-[1000px] opacity-100 scale-y-100 py-2"
            : "max-h-0 opacity-0 scale-y-0"
        } origin-top`}
      >
        <div className="p-4 border-t border-gray-200 [&_a]:text-is2-blue [&_a]:no-underline">{content}</div>
      </div>
    </div>
  );
};

export default Accordion;
